var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.6001 11.9996C3.6001 14.2274 4.4851 16.364 6.0604 17.9393C7.63571 19.5146 9.77228 20.3996 12.0001 20.3996C14.2279 20.3996 16.3645 19.5146 17.9398 17.9393C19.5151 16.364 20.4001 14.2274 20.4001 11.9996C20.4001 9.77179 19.5151 7.63522 17.9398 6.05991C16.3645 4.48461 14.2279 3.59961 12.0001 3.59961C9.77228 3.59961 7.63571 4.48461 6.0604 6.05991C4.4851 7.63522 3.6001 9.77179 3.6001 11.9996V11.9996Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624813",
    x: 11.04,
    y: 11.1602,
    width: 1.92,
    height: 5.4,
    rx: 0.96,
    fill: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.40039C11.8812 8.40039 11.7652 8.43558 11.6666 8.50151C11.5679 8.56744 11.491 8.66115 11.4456 8.77078C11.4002 8.88042 11.3883 9.00106 11.4114 9.11745C11.4346 9.23383 11.4917 9.34074 11.5756 9.42466C11.6595 9.50857 11.7665 9.56571 11.8828 9.58886C11.9992 9.61201 12.1199 9.60013 12.2295 9.55472C12.3392 9.50931 12.4329 9.4324 12.4988 9.33373C12.5647 9.23506 12.5999 9.11906 12.5999 9.00039C12.5999 8.84126 12.5367 8.68865 12.4242 8.57613C12.3116 8.4636 12.159 8.40039 11.9999 8.40039Z",
    fill: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.40039C11.8812 8.40039 11.7652 8.43558 11.6666 8.50151C11.5679 8.56744 11.491 8.66115 11.4456 8.77078C11.4002 8.88042 11.3883 9.00106 11.4114 9.11745C11.4346 9.23383 11.4917 9.34074 11.5756 9.42466C11.6595 9.50857 11.7665 9.56571 11.8828 9.58886C11.9992 9.61201 12.1199 9.60013 12.2295 9.55472C12.3392 9.50931 12.4329 9.4324 12.4988 9.33373C12.5647 9.23506 12.5999 9.11906 12.5999 9.00039C12.5999 8.84126 12.5367 8.68865 12.4242 8.57613C12.3116 8.4636 12.159 8.40039 11.9999 8.40039",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredInfo);
export default __webpack_public_path__ + "static/media/ic-colored-info.1eecba083e5624d8a61720447709d96d.svg";
export { ForwardRef as ReactComponent };